import { GERMAN_DATE_TIME_WITH_DAYOFWEEK_PIPE_FORMAT, ENGLISH_DATE_TIME_WITH_DAYOFWEEK_PIPE_FORMAT }
    from './../../../common/model/constants';
import { Component, OnInit } from '@angular/core';
import { HisBaseGlobalsService, HisUiService, HisNotificationService } from 'hisng';
import { WebTimeRecord } from './../../model/webtimerecord';
import { WebTimeRecordType } from './../../model/webtimerecordtype';
import { TimeManagementService } from '../../service/timemanagement.service';

@Component( {
    selector: 'app-webtime',
    templateUrl: './webtime.component.html'
} )
export class WebTimeComponent implements OnInit {
    readonly WEB_TIME_RECORD_TYPE = WebTimeRecordType;

    readonly dateTimeFormat: string;
    webTimeRecord?: WebTimeRecord;
    webTimeRecordTypeLabel?: string;
    defaultBookingType?: string;
    selectedBookingType?: string;
    isWebTimeRecordLoaded = false;
    isTimeChipPresentAndActive = false;
    showButtonBusinessErrand = true;

    constructor(
        private readonly hisUiService: HisUiService,
        private readonly hisNotificationService: HisNotificationService,
        private readonly hisBaseGlobalsService: HisBaseGlobalsService,
        private readonly webTimeService: TimeManagementService,
    ) {
        this.dateTimeFormat = this.hisBaseGlobalsService.getLanguage() === 'de'
            ? GERMAN_DATE_TIME_WITH_DAYOFWEEK_PIPE_FORMAT : ENGLISH_DATE_TIME_WITH_DAYOFWEEK_PIPE_FORMAT;
    }

    ngOnInit(): void {
        this.fetchDefaultBookingType();
        this.checkTimeChipPresentAndActive();
        this.checkBusinessErrandActive();
        this.getLastRecord();
    }

    createRecordCome(): void {
        switch (this.selectedBookingType) {
            case 'office':
                this.createRecord(WebTimeRecordType.TERMINAL_COME);
                break;
            case 'mobileworking':
                this.createRecord(WebTimeRecordType.MOBILE_WORKING_COME);
                break;
            default:
                this.hisNotificationService.error(
                    this.hisUiService.translate( 'rm.erp.timemanagement.webtimerecord.message.error.noBookingType' ),
                    this.hisUiService.translate( 'fs.res.common.service.error' ), 5000
                );
                break;
        }
    }

    createRecordLeave(): void {
        /*
            HINWEIS: Hier muss nicht zwischen Büro- und Mobile Workingbuchung unterschieden werden.
            Das Backend setzt bei einer Gehen-Buchung die Buchungsart automatisch auf die Buchungsart der Kommen-Buchung.
        */
        this.createRecord(WebTimeRecordType.TERMINAL_LEAVE);
    }

    createRecordBusinessErrand(): void {
        this.createRecord(WebTimeRecordType.BUSINESS_ERRAND);
    }

    isDefaultBookingTypeOfficeOrMobileWorking(): boolean {
        return this.defaultBookingType === 'B' || this.defaultBookingType === 'MW';
    }

    isLastBookingTypeCome(): boolean  {
        if ( this.webTimeRecord === undefined || this.webTimeRecord === null) {
            return false;
        }

        return this.webTimeRecord.recordType === this.WEB_TIME_RECORD_TYPE.TERMINAL_COME
            || this.webTimeRecord.recordType === this.WEB_TIME_RECORD_TYPE.MOBILE_WORKING_COME;
    }

    private getLastRecord(): void {
        this.webTimeService.getLastWebTimeRecord().subscribe( record => {
            this.webTimeRecord = record;
            if ( this.webTimeRecord ) {
                this.setWebTimeRecordTypeLabel( this.webTimeRecord.recordType );
            }
            this.isWebTimeRecordLoaded = true;
        } );
    }

    private fetchDefaultBookingType(): void {
        this.webTimeService.getDefaultBookingType().subscribe( bookingType => {
            this.defaultBookingType = bookingType;
            this.setSelectedBookingType();
        } );
    }

    private setSelectedBookingType(): void {
        switch (this.defaultBookingType) {
            case 'B':
                this.selectedBookingType = 'office';
                break;
            case 'MW':
                this.selectedBookingType = 'mobileworking';
                break;
            default:
                break;
        }
    }

    private checkTimeChipPresentAndActive(): void {
        this.webTimeService.isTimeChipPresentAndActive().subscribe( isActive => {
            this.isTimeChipPresentAndActive = isActive;
        } );
    }

    private checkBusinessErrandActive(): void {
        this.webTimeService.isBusinessErrandActive().subscribe( isActive => {
            this.showButtonBusinessErrand = isActive;
        } );
    }

    private createRecord( recordType: WebTimeRecordType ): void {
        this.webTimeService.createWebTimeRecord( recordType ).subscribe({
            next: (createdRecord) => {
                this.webTimeRecord = createdRecord.dto;
                this.setWebTimeRecordTypeLabel( createdRecord.dto.recordType );
                this.hisNotificationService.successI18n( 'rm.erp.timemanagement.webtimerecord.message.success',
                    this.webTimeRecordTypeLabel );
            },
            error: () => {
                this.hisNotificationService.errorI18n( 'rm.erp.timemanagement.webtimerecord.message.error' );
            }
        });
    }

    private setWebTimeRecordTypeLabel( recordType: WebTimeRecordType ): void {
        this.webTimeRecordTypeLabel = this.hisUiService.translate( this.getWebTimeRecordTypeLabelKey( recordType ) );
    }

    private getWebTimeRecordTypeLabelKey( recordType: WebTimeRecordType ): string {
        switch ( recordType ) {
            case WebTimeRecordType.TERMINAL_COME:
                return 'rm.erp.timemanagement.webtimerecord.label.come';
            case WebTimeRecordType.TERMINAL_LEAVE:
                return 'rm.erp.timemanagement.webtimerecord.label.leave';
            case WebTimeRecordType.BUSINESS_ERRAND:
                return 'rm.erp.timemanagement.webtimerecord.label.businesserrand';
            case WebTimeRecordType.MOBILE_WORKING_COME:
                return 'rm.erp.timemanagement.webtimerecord.label.mobileworking.come';
            case WebTimeRecordType.MOBILE_WORKING_LEAVE:
                return 'rm.erp.timemanagement.webtimerecord.label.mobileworking.leave';
        }
    }
}
